/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { registerAgGridModules } from './app/global/components/ag-grid/ag-grid.config';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import 'bootstrap';

registerAgGridModules();

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
